import animationManager, {
  makeSequence,
} from "../../../../../../shared/services/animation-manager";
import { mainDrawerHTMLSelector, RouteChangeCallbacks } from "./common";

export function registerForwardToNextMenuSequence({
  onSlideMainDrawerOutEnd,
}: RouteChangeCallbacks): void {
  animationManager.register(
    "transitionNextLevelDoubleDrawer",
    makeSequence([
      [
        {
          elementSelector: "#side-drawer > div",
          animation: {
            className: `translate-forward-animation-out`,
          },
        },
        {
          elementSelector: mainDrawerHTMLSelector,
          animation: {
            className: `translate-forward-animation-out`,
            cleanUpAfterAnimation: (element) => {
              element.style.display = "none";
            },
          },
          onEnd: onSlideMainDrawerOutEnd,
        },
      ],
      [
        {
          elementSelector: "#side-drawer > div",
          animation: {
            className: `translate-forward-animation-in`,
          },
        },
        {
          elementSelector: mainDrawerHTMLSelector,
          animation: {
            className: `translate-forward-animation-in`,
            cleanUpBeforeAnimation: (element) => {
              element.style.display = "block";
            },
          },
        },
      ],
    ]),
  );
}
